import { OPEN_DIALOG, CLOSE_DIALOG } from 'constants/actionTypes';
import { CHECK_YOUR_EMAIL } from 'constants/dialogs';

const defaultState = {
  [CHECK_YOUR_EMAIL]: false,
};

function dialogReducer(state = defaultState, action) {
  switch (action.type) {
    case OPEN_DIALOG:
      return {
        ...state,
        [action.payload]: true,
      };
    case CLOSE_DIALOG:
      return {
        ...state,
        [action.payload]: false,
      };
    default:
      return state;
  }
}

export default dialogReducer;
